import React, { useCallback, useEffect, useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CommonButtonVariants } from '../constants/CommonButtonVariants';
import CommonButton from '../common/components/CommonButton';
import RouterPaths from '../constants/RouterPaths';
import { clearCompanyDetails } from './RegisterActions';
import logo from '../assets/img/icons/logo-desktop.svg';
import logoMobile from '../assets/img/logo-mobile.png';
import blackWhiteConvertible from '../assets/img/black-white-convertible-min.png';

import { useMediaQuery } from '../common/hooks/useMediaQuery';

function RegisterSuccess() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const logoSrc = useMemo(() => (isMobile ? logoMobile : logo), [isMobile]);
  const clearCompanyDetailsCallback = useCallback(
    () => dispatch(clearCompanyDetails()),
    [dispatch],
  );

  useEffect(() => clearCompanyDetailsCallback, [clearCompanyDetailsCallback]);

  const handleHomeClick = useCallback(() => {
    dispatch(clearCompanyDetails());
    navigate(RouterPaths.HOMEPAGE);
  }, [dispatch, navigate]);

  return (
    <div className="register-page">
      <Row>
        <Col md={12} sm={12} className="relative register-page__steps-column">
          <div className="register-page__steps-header">
            <Link to={RouterPaths.HOMEPAGE} className="page-logo-link">
              <img src={logoSrc} alt="logo" />
            </Link>
            <h2 className="register-success-title" style={{ marginTop: '64px' }}>
              Thank you for registering
            </h2>
            <p>
              Thank you for registering for The Stock Vault. A member of our team will verify
              your account, and you will soon be able to access a wealth of dealer-exclusive
              stock. For franchised dealers, once your account is verified, you’ll also be able
              to list stock.
            </p>
          </div>

          <Col
            md="12"
            className="register-form-container d-flex flex-column justify-content-center align-items-center"
          >
            <Row md={12} className="register-form-container__content w-100">
              <CommonButton
                label="Home page"
                handleClick={handleHomeClick}
                className="register-form-success-button auth__homepage-button"
                variant={CommonButtonVariants.OUTLINED_RED}
              />
            </Row>
            <img
              src={blackWhiteConvertible}
              alt="Black and White Convertible"
              className="auth__register-image"
            />
          </Col>
        </Col>
      </Row>
    </div>
  );
}

export default RegisterSuccess;
